import axios from "axios";
import { toast } from "react-toastify";
export const GetAllLoanPayment = (data) => {
  return {
    type: "get_allgetloanpayment",
    payload: data,
    loader: false,
  };
};
export function getallLoanPayment() {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/LoanPayment/Populate?ProjectId=${localStorage.getItem(
      "ProjectId"
    )}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/LoanPayment/Populate`;
    }
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLoanPayment(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllLoanPayTableData = (data) => {
  return {
    type: "get_allloanpaytabledata",
    payload: data,
    loader: false,
  };
};
export function getallrecoverypopulatetable(data) {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/LoanPayment/Get?projectid=${localStorage.getItem("ProjectId")}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/LoanPayment/Get`;
    }
    axios({
      url: pgurl,
      method: "Post",
      data: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLoanPayTableData(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
